export const WORKSPACES = [
  { id: "dashboard", label: "Dashboard", path: "/dashboard" },
  { id: "my_day", label: "My Day", path: "/my-day" },
  { id: "tasks", label: "Task Tracker", path: "/tasks" },
  { id: "structure", label: "Tenant Structure", path: "/admin/structure" },
  { id: "contacts", label: "Leads / Contacts", path: "/contacts" },
  { id: "referrals", label: "Referrals", path: "/referrals" },
  { id: "organizations", label: "Organizations", path: "/organizations" },
  { id: "relationship_contacts", label: "Contact Persons", path: "/relationship-contacts" },
  { id: "osa_results", label: "OSA Results & Eligibility", path: "/osa-results" },
  { id: "staff_invoices", label: "Staff Invoicing", path: "/staff-invoices" },
  { id: "opportunities", label: "Opportunities", path: "/opportunities" },
  { id: "calendar", label: "Calendar", path: "/calendar" },
  { id: "visit_verification", label: "Visit Verification", path: "/visit-verification" },
  { id: "my_performance", label: "My Performance", path: "/my-performance" },
  { id: "expenses", label: "Reimbursement Requests", path: "/expenses" },
  { id: "training", label: "Training", path: "/training" },
  { id: "coaching", label: "Coaching", path: "/coaching" },
  { id: "complaints", label: "Complaints & Cases", path: "/complaints" },
  { id: "suggestions", label: "Suggestion Box", path: "/suggestions" },
  { id: "user_360", label: "User 360", path: "/user-360" },
  { id: "imports", label: "Imports", path: "/imports" },
  { id: "reports", label: "Reports", path: "/reports" },
] as const;

export type WorkspaceId = typeof WORKSPACES[number]["id"];

export function hasWorkspaceAccess(user: any, workspace: WorkspaceId): boolean {
  if (!user || user.scope === "platform" || user.tenant_role === "owner_admin") return true;
  const configured = user.workspace_access;
  return !Array.isArray(configured) || configured.includes(workspace);
}


export const ACTIONS = [
  { id: "view", label: "View" },
  { id: "add", label: "Add" },
  { id: "edit", label: "Edit" },
  { id: "archive", label: "Archive" },
  { id: "restore", label: "Restore" },
  { id: "deactivate", label: "Deactivate" },
  { id: "delete", label: "Delete" },
] as const;

export type ActionId = typeof ACTIONS[number]["id"];
export type ActionAccess = Partial<Record<WorkspaceId, ActionId[]>>;

export function hasActionAccess(user: any, workspace: WorkspaceId, action: ActionId): boolean {
  if (!user || user.scope === "platform" || user.tenant_role === "owner_admin") return true;
  const configured = user.action_access;
  if (!configured || typeof configured !== "object") return true;
  return Array.isArray(configured[workspace]) && configured[workspace].includes(action);
}
